import { z } from "zod";

// This is what the backend expects in details.exchange_questions.NYSE
// https://github.com/alpacahq/gobroker/blob/develop/integration/suite/suite_test.go#L548
export const nyseQuestionsSchema = z.object({
  qA: z.boolean(),
  qB: z.boolean(),
  qC: z.boolean(),
  qD: z.boolean(),
  qE: z.boolean(),
  qF: z.boolean(),
  qG: z.boolean(),
  qH: z.boolean(),
  qI: z.boolean(),
  qJ: z.boolean(),
  qK: z.boolean(),
});

export type NyseQuestionsSchema = z.infer<typeof nyseQuestionsSchema>;

export const getIsProfessional = (values: NyseQuestionsSchema) => {
  const { qA, ...rest } = values;

  // if qA is false (not null/undefined)
  // or any other q is true -> is_professional is true
  return qA === false || Object.values(rest).some((value) => value === true);
};
